// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/revivers')
// Sibling imports
const RecReasonRecord = require('./rec-reason')

class FeedItemMetaRecord extends Immutable.Record({
  rating: null,
  recId: null,
  recPosition: null,
  recReason: null
}) {
  // No methods
}

FeedItemMetaRecord.reviver = keyedReviver(FeedItemMetaRecord, {
  recReason: RecReasonRecord.reviver
})

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  FeedItemMetaRecord.propTypes = {
    rating: PropTypes.oneOf([ 'up', 'down', 'none' ]),
    recId: PropTypes.string,
    recPosition: PropTypes.number,
    recReason: PropTypes.shape(RecReasonRecord.propTypes)
  }
}

module.exports = FeedItemMetaRecord
